
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cara-pembayaran/electronic-money",
      function () {
        return require("private-next-pages/cara-pembayaran/electronic-money.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cara-pembayaran/electronic-money"])
      });
    }
  